//extracted by mini-css-extract-plugin
export default {"errorContainer":"styles_errorContainer__bDTty","msgContainer":"styles_msgContainer__5g7cT","msgBody":"styles_msgBody__ZUdib"};;